import { styled } from '@/styled-system/jsx';
import Title from 'app/shared/modules/Title';

export const CostAndFeesModalContainer = styled('div', {
  base: {
    width: '100%',
  },
});

export const CostAndFeesBreakdownBoxWrapper = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2x',
  },
});

export const DisclaimerText = styled('div', {
  base: {
    color: 'hpxGrey500',
    fontWeight: '400',
    fontSize: 'sm',
    lineHeight: 'tiny',
    mt: '1x',
  },
});

export const DisclaimerTextResponsive = styled('div', {
  base: {
    color: 'hpxGrey500',
    fontWeight: '400',
    fontSize: 'sm',
    lineHeight: 'tiny',
    marginTop: '16px',
  },
  variants: {
    variant: {
      desktop: {
        maxWidth: '300px',
        display: {
          base: 'none',
          lg: 'block',
        },
      },
      mobile: {
        display: {
          base: 'block',
          lg: 'none',
        },
      },
    },
  },
});

export const TitleWrapper = styled(Title, {
  base: {
    mb: '1x',
  },
});

export const ContentRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: {
      base: 'column',
      lg: 'row',
    },
    gap: '2x',
    width: '100%',
    flexWrap: 'wrap',
  },
});

export const ContentColumn = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1x',
    flex: 1,
  },
});
